var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1040,
    height: 747,
    viewBox: "0 0 1040 747",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.384 746.084C221.189 746.084 186.872 740.103 155.431 728.137C123.99 716.166 96.5347 699.325 73.067 677.608C50.0401 655.446 32.1062 629.739 19.2645 600.485C6.42285 571.234 0 539.1 0 504.086C0 469.071 6.42285 436.937 19.2645 407.683C32.1062 378.431 50.0401 352.945 73.067 331.227C96.5347 309.066 123.99 292.002 155.431 280.035C186.872 268.068 221.189 262.084 258.384 262.084C296.028 262.084 330.346 268.068 361.342 280.035C392.784 292.002 420.017 309.066 443.044 331.227C466.071 352.945 484.005 378.431 496.847 407.683C510.129 436.937 516.773 469.071 516.773 504.086C516.773 539.1 510.129 571.455 496.847 601.152C484.005 630.403 466.071 655.888 443.044 677.608C420.017 699.325 392.784 716.166 361.342 728.137C330.346 740.103 296.028 746.084 258.384 746.084ZM258.384 637.051C276.098 637.051 292.482 633.95 307.539 627.744C323.038 621.541 336.324 612.676 347.395 601.152C358.906 589.186 367.765 574.999 373.963 558.6C380.607 542.201 383.924 524.028 383.924 504.086C383.924 483.697 380.607 465.524 373.963 449.567C367.765 433.168 358.906 419.207 347.395 407.683C336.324 395.716 323.038 386.63 307.539 380.425C292.482 374.22 276.098 371.117 258.384 371.117C240.674 371.117 224.066 374.22 208.568 380.425C193.515 386.63 180.229 395.716 168.713 407.683C157.642 419.207 148.787 433.168 142.144 449.567C135.945 465.524 132.848 483.697 132.848 504.086C132.848 524.028 135.945 542.201 142.144 558.6C148.787 574.999 157.642 589.186 168.713 601.152C180.229 612.676 193.515 621.541 208.568 627.744C224.066 633.95 240.674 637.051 258.384 637.051Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M575.605 738.183L575.637 271.938L717.285 271.855V544.591L914.062 271.855H1040V738.1H910.481V464.244L711.303 738.1L575.605 738.183Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M642.207 122.059L914.094 122.059V197.24H717.174L642.207 122.059Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M869.95 0H763.92L723.768 40.2647L723.774 40.2661L642.207 122.062L695.22 175.225L869.699 0.254349L869.698 0.253457C869.782 0.169069 869.866 0.0845836 869.95 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5601_45151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 642,
    y: 0,
    width: 228,
    height: 176
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M869.95 9.15527e-05H763.92L723.768 40.2648L723.774 40.2662L642.207 122.062L695.22 175.225L869.699 0.25444L869.698 0.253549C869.782 0.169161 869.866 0.0846752 869.95 9.15527e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5601_45151)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5601_45151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.207 122.059L914.094 122.059V197.24H717.174L642.207 122.059Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5601_45151",
    x: 570.79,
    y: 62.3012,
    width: 395.887,
    height: 199.181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.41707,
    dy: 2.24216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.4 0 0 0 0 0.6 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5601_45151"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5601_45151",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOi);
export default __webpack_public_path__ + "static/media/oi.f7041617ca970ed9e27ad61b3acd3066.svg";
export { ForwardRef as ReactComponent };